




































































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import tipsModel from "./Details/tipsModel.vue";
import {
  chargeGameList,
  chargeStatus,
  shiwanStatus,
  gameList,
} from "@/req/gameManage";
@Component({
  components: {
    headerTitle,
    tipsModel,
  },
})
export default class Home extends Vue {
  public loading = false;
  public gameId: any = "";
  public gameName: any = "";
  public gameList: any = [];
  public columns = [
    {
      title: "游戏名称",
      key: "game_name",
      align: "center",
    },
    {
      title: "创建时间",
      key: "add_time",
      align: "center",
      render: (h, params) => {
        return h(
          "span",
          {
            props: {},
          },
          this.$fn.toDateSymbol(params.row.add_time)
        );
      },
    },
    {
      title: "游戏状态",
      key: "jyh_status",
      slot: "jyh_status",
      align: "center",
    },
    {
      title: "试玩开关",
      key: "jyh_shiwan_status",
      slot: "jyh_shiwan_status",
      align: "center",
    },
    {
      title: "操作",
      key: "action",
      slot: "action",
      align: "center",
    },
  ];
  public data: any = [
    {
      box_game_id: "6",
      game_name: "梦回复古",
      create_time: "1608912000",
      state: 1,
    },
    {
      box_game_id: "11",
      game_name: "浴血传奇",
      create_time: "1608912000",
      state: 2,
    },
    {
      box_game_id: "12",
      game_name: "冰凛城下",
      create_time: "1608912000",
      state: 1,
    },
  ];
  public pageNum = 1;
  public pageSize = 20;
  public getAddGame() {
    this.$router.push({
      path: "/details",
    });
  }
  public getEditGame(row) {
    this.$router.push({
      path: "/editDetail",
      query: { gameId: row.box_game_id },
    });
  }
  public mounted() {
    this.getList();
    this.getGameList();
  }
  public async getGameList() {
    const res = await gameList({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      res.data.forEach((item) => {
        item.box_game_id = item.box_game_id.toString();
      });
      this.gameList = res.data;
    }
  }
  public search() {
    this.pageNum = 1;
    this.getList();
  }
  public async getList() {
    const obj: any = {
      token: this.$fn.cookies.getToken("token"),
      limit: this.pageSize,
      page: this.pageNum,
      game_name: this.gameName || "",
      game_id: this.gameId || "",
    };
    this.loading = true;
    const res = await chargeGameList(obj);
    if (res.code == 0) {
      this.data = res.data;
      this.loading = false;
    }
  }
  public async addAction(row, state) {
    const $tipsModel: any = this.$refs.tipsModel;
    $tipsModel.show(true, row.box_game_id, state);
  }
  // 落地页配置状态
  public async tshowIds(row) {
    let types;
    if (row.jyh_shiwan_status == 0) {
      types = 1;
      const obj = {
        token: this.$fn.cookies.getToken("token"),
        box_game_id: row.box_game_id,
        type: types,
      };
      const res = await shiwanStatus(obj);
      if (res.code == 0) {
        this.$Message.info(res.msg);
        this.loading = true;
        setTimeout(() => {
          this.getList();
        }, 1000);
      }
    } else {
      types = 2;
      const obj = {
        token: this.$fn.cookies.getToken("token"),
        box_game_id: row.box_game_id,
        type: types,
      };
      const res = await shiwanStatus(obj);
      if (res.code == 0) {
        this.$Message.info(res.msg);
        this.loading = true;
        setTimeout(() => {
          this.getList();
        }, 1000);
      }
    }
  }
  public pageChange(i) {
    this.pageNum = i;
    this.getList();
  }
  public sizeChange(i) {
    this.pageSize = i;
    this.pageNum = 1;
    this.getList();
  }
}
